/* eslint-disable jsx-a11y/anchor-is-valid */
import { IState, useMainStore } from "@/settings/zustand"
import { Icon } from "@blueprintjs/core"
import { ID, IMenuItem, MENU_ANIMATE_DELAY } from "@libs/interfaces/layouts"
import { getRoute, moduleExists, template } from "@libs/layouts"
import { LayoutIcon } from "@libs/useful"
import { __, isCapability } from "@libs/utilities"
import { CSSProperties, MouseEvent, useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { useAnimated } from "src/modules/pe-landing-module/hooks/useAnimated"
import { isRouteOpen } from "../utils/isRouteOpen"
import { useAnimatedStyle } from "src/modules/pe-landing-module/hooks/useAnimatedStyle"

interface IProps {
    item: IMenuItem
    i: number
    onRoute?: (route: any) => void
    pt?: string
    isForceOpen?:boolean
    header_menu?: "iconic" | "inline"
    className?: string
    style?: CSSProperties
}
const HeaderMenuMainButton = ({item, i, ...props}: IProps) :JSX.Element => {
    const user = useMainStore(( state: IState ) => state.user)
    const landId:ID = useMainStore( ( state: IState ) => state.landId )
    const [isOpen, setIsOpen] = useState<boolean>( !!props.isForceOpen ) 
    
    useEffect(() => useMainStore.subscribe(
        ( state: IState ) => {
            //console.log( item.title, landId )
            return setIsOpen( !!props.isForceOpen || isRouteOpen( item, landId, state.event_types ) )
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [ landId ])

    const onRoute = () => {
        if(props.onRoute) {
            props.onRoute( getRoute(item) )
        }        
    } 
    const delay = ` transition-delay-${ Math.floor( Math.random() * 4 ) * 200 }`
    const duration = ` transition-duration-${ Math.floor( Math.random() * 4 ) * 500 } ${delay} `
    
    return <MenuLink  
        {...{item, i, ...props}}
        isOpen={isOpen} 
        onRoute={onRoute} 
        
        i={i}
    >
        <div 
            className={ `header-menu-element ${ props.header_menu || template().header_menu } ${ isOpen ? "opened" : "closed" } ${ duration } ${props.className} ` } 
            style={props.style} 
        >
            <LayoutIcon
                src={ item.icon || ""}
                className="header-menu-icon" 
            />
            <span className='header-menu-label'>
                <span>
                    { __( item.title ) }
                </span>
                
            </span>
            {
                !!(item.children || []).filter( ch => {
                    return !!props.isForceOpen || (!ch.is_hidden && moduleExists( ch.module )) || isCapability(ch.capability, user)
                    }).length && 
                <Icon icon="caret-down" className=" ml-2"/>
            }  
        </div>
    </MenuLink> 
} 


/*
    <MenuLink  
        {...{item, i, ...props}}
        isOpen={isOpen} 
    >
*/

export default HeaderMenuMainButton

export interface IMenuLinkProps extends IProps {
    isOpen: boolean
    children: JSX.Element
    onRoute?: ( route: any ) => void 
    i:number
}
export const MenuLink = (props: IMenuLinkProps): JSX.Element => { 
    const {item, isOpen, children, i} = props

    
    const getAnimateDelay = () => {
        switch (item.animated_delay) {
            case MENU_ANIMATE_DELAY.WATERFALL:
                const ii = ( props.i || 0 ) % 6
                return ii === 0 ? "" : ii
            case MENU_ANIMATE_DELAY.NONE:
                return ""
            default:
                return item.animated_delay
        }
    }
    const animated_delay = getAnimateDelay() 
    const ref = useRef(null)
    useAnimated( ref, animated_delay )
    const animate = useAnimatedStyle(item, i)

    const onAnchor = ( evt: MouseEvent, element: any ) => {
        evt.stopPropagation()
        evt.preventDefault() 
        if(props.onRoute) {
            props.onRoute( element )
        }      
    } 

    const onRoute = ( ) => { 
        if(props.onRoute) {
            props.onRoute( getRoute(item) )
        }        
    } 
    if(!!item.isDisable) {
        return <a href="#" aria-disabled="false" className={`pt-${props.pt} ${animate} ${ isOpen ? "opened" : "closed" }`} onClick={(evt: MouseEvent) => onAnchor(evt, ref.current) } ref={ref}>
            {children}
        </a>
    }
    if(item.route?.toString().indexOf("#") === 0) {
        return <a href={item.route.toString()} className={`pt-${props.pt} ${animate} ${ isOpen ? "opened" : "closed" }`} onClick={(evt: MouseEvent) => onAnchor(evt, ref.current) } ref={ref}>
            {children}
        </a>
    }
    else if(item.route?.toString().indexOf("http") === 0) {
        return <a href={item.route.toString()} className={`pt-${props.pt} ${animate} ${ isOpen ? "opened" : "closed" }`} onClick={onRoute} ref={ref}>
            {children}
        </a>
    }
    else {
        return <Link 
            onClick={ onRoute }
            to={ `/${ getRoute(item) }` } 
            className={`pt-${props.pt} ${animate} ${ isOpen ? "opened" : "closed" }`}
            data-testid="header-menu-main-button"
            ref={ref}
        >
            {children}
        </Link>
    }
}


